module.exports = {"url":"http://plan.shoprite.com/User/Authenticate?mgl=15DFAA81-9DFA-4187-AB9B-E1E408A9EE8E_Redirect&timestamp=12312123455"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/js/shopriteSSORedirectLink.json
// module id = 388
// module chunks = 0